var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":_vm.$t('dictionary.user')}}),(_vm.isOperation)?_c('a-alert',{staticClass:"mt-2",attrs:{"message":_vm.$t('common_611'),"type":"info"}}):_vm._e(),_c('page-body',[_c('list',{attrs:{"id":_vm.listId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }